import React, { ReactNode } from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import {
  Layout,
  Collapse,
  Typography,
  Spin,
  Col,
  Row,
  Space,
  Steps
} from "antd";
import { ILegalViewDetailsPresenter } from "../../presenter/LegalViewDetailsPresenter";
import OrganisationIndexTag from "../../../organisations/ui/components/OrganisationIndexTag";
import LegalViewSidebar from "../components/LegalViewSidebar";
import AttachmentTable from "../../../caseLawDocuments/ui/components/AttachmentTable";
import HeadingLabel from "../../../core/ui/components/HeadingLabel";
import Constants, { LegalViewStatus } from "../../common/Constants";
import LegalViewStatusSteps from "../components/LegalViewStatusSteps";
import { LockFilled } from "@ant-design/icons";
const { Title } = Typography;
const { Content, Sider } = Layout;
const { Panel } = Collapse;
const { Step } = Steps;
export interface Props extends PageProps {}

export interface State extends ILegalViewDetailsPresenter {}

const renderPanel = (title: string, component: ReactNode) => {
  return (
    <Collapse defaultActiveKey={"0"} key={`details-panel-${title}`}>
      <Panel
        header={
          <span
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: 500
            }}
          >
            {title}
          </span>
        }
        key="0"
      >
        <div style={{ marginLeft: 24 }}>{component}</div>
      </Panel>
    </Collapse>
  );
};

export default class LegalViewDetailsPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props, current: 0 };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }
  render() {
    const {
      translate,
      legalView,
      legalViewTypes,
      organisations,
      attachments,
      attachmentTypes,
      attachmentContentTypes,
      indexHierarchyList,
      selectedLanguage,
      showLegalViewUpdatePage,
      canEdit,
      showLegalViewDetailsPage,
      publishLegalView,
      archiveLegalView,
      anonimisedUploadedFile,
      setAnonymisedFileValue,
      revertLegalViewStatus,
      deleteLegalView,
      user
    } = this.state;

    let translation = legalView?.summaryTranslations?.find(
      (t) => t.languageId === selectedLanguage.id
    );
    return (
      <Page {...this.props} className={"page-wrapper"}>
        <Spin spinning={this.state.loaders.legalViewDetailsLoader}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={10} xl={5}>
              <Title level={1} style={{ marginBottom: 30 }}>
                {translate("editors.legal_views.legal_view")}
              </Title>
            </Col>
            <Col xs={24} sm={24} md={14} xl={19}>
              <Row justify="space-around" align="middle">
                {canEdit?.(legalView.organisationId) ? (
                  <Col span={24}>
                    <div className={"png-steps-wrapper"}>
                      <LegalViewStatusSteps
                        status={legalView.status}
                        onClick={() => {
                          showLegalViewDetailsPage(legalView.invalidatedBy);
                        }}
                        translate={translate}
                      />
                    </div>
                  </Col>
                ) : null}
              </Row>
            </Col>
          </Row>
          <Layout>
            <Layout>
              {canEdit(legalView.organisationId) &&
                legalView?.status !== LegalViewStatus.ARCHIVED && (
                  <Sider
                    className={"content-container dashboard-sider"}
                    breakpoint="xl"
                    collapsible
                    collapsedWidth="0"
                    width={"20%"}
                    style={{ height: 250 }}
                  >
                    <LegalViewSidebar
                      user={user}
                      translate={translate}
                      legalView={legalView}
                      legalViewTypes={legalViewTypes}
                      organisations={organisations}
                      onEditClick={showLegalViewUpdatePage}
                      publishLegalView={publishLegalView}
                      archiveLegalView={archiveLegalView}
                      onUndoClick={revertLegalViewStatus}
                      deleteLegalView={deleteLegalView}
                    />
                  </Sider>
                )}
              <Layout className={"dashboard-content-wrapper"}>
                <Content className="site-layout-background dashboard-content-container">
                  <Row gutter={[16, 8]} className={"mx-0 mb-4"}>
                    <Col span={24}>
                      <Space direction="vertical" style={{ width: "100%" }}>
                        {renderPanel(
                          translate("editors.legal_views.basic_data"),
                          <>
                            <Row>
                              <Col>
                                <HeadingLabel
                                  text={translate(
                                    "editors.legal_views.fields.organisation_name"
                                  )}
                                />
                                <p>{legalView.organisationName}</p>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <HeadingLabel
                                  text={translate(
                                    "editors.legal_views.fields.summary"
                                  )}
                                />
                                <p style={{ whiteSpace: "pre-line" }}>
                                  {translation?.summaryTranslation ??
                                    legalView.summary}
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <HeadingLabel
                                  text={translate(
                                    "editors.legal_views.fields.note"
                                  )}
                                />
                                <p style={{ whiteSpace: "pre-line" }}>
                                  {translation?.noteTranslation ??
                                    legalView.note}
                                </p>
                              </Col>
                            </Row>

                            {legalView.formattedDate ? (
                              <Row>
                                <Col>
                                  <HeadingLabel
                                    text={translate("editors.legal_views.date")}
                                  />
                                  <p>{legalView.formattedDate}</p>
                                </Col>
                              </Row>
                            ) : null}

                            {false && (
                              <Row>
                                <Col>
                                  <HeadingLabel
                                    text={translate(
                                      "editors.legal_views.fields.legal_view_type"
                                    )}
                                  />
                                  <p>{legalView.legalViewTypeName}</p>
                                </Col>
                              </Row>
                            )}
                          </>
                        )}
                        {attachments.length > 0 &&
                          renderPanel(
                            translate("editors.legal_views.attachments"),
                            <>
                              <AttachmentTable
                                translate={translate}
                                attachmentTypes={attachmentTypes}
                                attachments={attachments}
                                editable={false}
                                contentTypes={attachmentContentTypes}
                                item={legalView}
                                organisationId={legalView.organisationId}
                                basePath={Constants.endpointBasePath}
                                canDownload={canEdit}
                                anonimisedUploadedFile={anonimisedUploadedFile}
                                setAnonymisedFileValue={setAnonymisedFileValue}
                              />
                            </>
                          )}
                        {indexHierarchyList.length > 0 &&
                          renderPanel(
                            translate("editors.legal_views.fields.index_data"),
                            <>
                              {indexHierarchyList?.map((indexHierarchy) => (
                                <OrganisationIndexTag
                                  indexHierarchyList={indexHierarchy}
                                />
                              ))}
                            </>
                          )}
                      </Space>
                    </Col>
                  </Row>
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </Spin>
      </Page>
    );
  }
}
